import React from 'react';
import { Prompt } from 'react-router-dom';
import { connect } from 'react-redux';
import { API_ROOT } from '../config';
import TrainingPageHeader from '../components/TrainingPageHeader';
import { BookOpen } from 'lucide-react';
import '../styles/TrainingTextSection.css';
import TrainingTextSectionViewer    from '../components/TrainingTextSection';
import TrainingVideoSection         from '../components/TrainingVideoSection';
import TrainingSliderSection        from '../components/TrainingSliderSection';
import TrainingAccordionSection     from '../components/TrainingAccordionSection';
import TrainingQuizSection          from '../components/TrainingQuizSection';



class TrainingTextSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formation: null, block: null, loading: true, error: null,
      dirty: false, viewedCount: 0,
      sectionReady: {},
      blockAlreadyApproved: false,
    };
    this.handleBeforeUnload = (e) => { e.preventDefault(); e.returnValue = ''; };
  }

  componentDidMount() {
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    this.loadData();
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  }

  async loadData() {
    const { userId, formationSlug, blockId } = this.props.match.params;
    const token = localStorage.getItem('token');
    try {
      const [formationRes, progressRes] = await Promise.all([
        fetch(`${API_ROOT}formations/${formationSlug}`, { headers: { Authorization: `Token ${token}` } }),
        fetch(`${API_ROOT}promoters/promoter/${userId}/formations`, { headers: { Authorization: `Token ${token}` } }),
      ]);
      if (!formationRes.ok) throw new Error('Error al cargar la formación');
      const formation = await formationRes.json();
      const block = (formation.blocks || []).find(b => b._id === blockId) || null;

      let blockAlreadyApproved = false;
      if (progressRes.ok) {
        const progressData = await progressRes.json();
        const entry = (progressData || []).find(e => e.formation?._id === formation._id || e.formation === formation._id);
        if (entry) {
          const bp = (entry.blocks || []).find(b => b.block === blockId || b.block?._id === blockId);
          if (bp?.approved) blockAlreadyApproved = true;
        }
      }

      const totalSections = (block?.sections || []).length;
      this.setState({
        formation, block, loading: false,
        dirty: !blockAlreadyApproved,
        blockAlreadyApproved,
        viewedCount: blockAlreadyApproved ? totalSections : 0,
      });
    } catch (err) {
      this.setState({ error: err.message, loading: false });
    }
  }



  render() {
    const { formation, block, loading, error, dirty, viewedCount, sectionReady, blockAlreadyApproved } = this.state;
    const { userId } = this.props.match.params;
    const isAdmin = this.props.role === 'ADMIN';
    const sections = block ? (block.sections || []) : [];
    const total = sections.length;
    const progress = total > 0 ? Math.round((viewedCount / total) * 100) : 0;
    const allDone = viewedCount >= total && total > 0;

    const needsReady = (type) => type === 'video' || type === 'slider' || type === 'accordion' || type === 'quiz';

    if (loading) return <div className="p-4">Cargando...</div>;
    if (error)   return <div className="p-4 text-danger">{error}</div>;
    if (!block)  return <div className="p-4 text-muted">Bloque no encontrado.</div>;

    const leftSection   = sections[0] || null;
    const rightSections = sections.slice(1);
    const hasRight      = rightSections.length > 0;

    const canContinueLeft = viewedCount === 0 && !allDone && leftSection &&
      (!needsReady(leftSection.type) || sectionReady[0]);

    const renderViewer = (section, idx) => (
      <>
        {section.type === 'text'      && <TrainingTextSectionViewer section={section} />}
        {section.type === 'video'     && <TrainingVideoSection      section={section} onReady={() => this.setState(prev => ({ sectionReady: { ...prev.sectionReady, [idx]: true } }))} />}
        {section.type === 'slider'    && <TrainingSliderSection     section={section} onReady={() => this.setState(prev => ({ sectionReady: { ...prev.sectionReady, [idx]: true } }))} />}
        {section.type === 'accordion' && <TrainingAccordionSection  section={section} onReady={() => this.setState(prev => ({ sectionReady: { ...prev.sectionReady, [idx]: true } }))} />}
        {section.type === 'quiz'      && <TrainingQuizSection       section={section} onReady={() => this.setState(prev => ({ sectionReady: { ...prev.sectionReady, [idx]: true } }))} />}
      </>
    );

    return (
      <>
        <Prompt when={dirty && !isAdmin} message="¿Seguro que quieres salir? Perderás el progreso no guardado." />

        {/* Wrapper: sticky como unidad, ambos paneles con scroll propio */}
        <div
          className="tts-layout d-flex"
          style={{
            position: 'sticky',
            top: 'var(--topbar-h)',
            height: 'calc(100vh - var(--topbar-h))',
            overflow: 'hidden',
            background: '#f8fafc',
            margin: '0 -12px',   /* cancela el padding p-3 del App.js */
          }}
        >
          {/* ── PANEL IZQUIERDO ── */}
          <div
            className="tts-panel-left p-3 bg-white border-end"
            style={{ width: hasRight ? '35%' : '100%', height: '100%', overflowY: 'auto' }}
          >
            <div className="titulo-container mb-4">
              <h5 className="titulo-formacion mb-3">{formation.name?.toUpperCase()}</h5>
              <h5 className="subtitulo-formacion mb-3">{block.name?.toUpperCase()}</h5>
            </div>
            <div className="progress-container mb-4">
              <div className="progress-bar-track">
                <div className="progress-bar-fill" style={{ width: `${progress}%` }} />
              </div>
              <span className="progress-bar-label">{viewedCount}/{total}</span>
            </div>

            {sections.length === 0 && <div className="text-muted">ERROR no cargan las secciones</div>}

            {leftSection && (
              <div className="training-section mb-4 border rounded p-3 w-100">
                <div className="section-title d-flex align-items-center justify-content-center gap-2 mb-2 w-100">
                  <strong>{leftSection.name}</strong>
                </div>
                {renderViewer(leftSection, 0)}
                {canContinueLeft && (
                  <div className="text-end mt-3">
                    <button
                      className="btn btn-primary"
                      onClick={() => this.setState(prev => ({ viewedCount: prev.viewedCount + 1 }))}
                    >
                      Continuar <i className="fas fa-arrow-right ms-2" />
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* ── PANEL DERECHO ── */}
          {hasRight && (
            <div className="tts-panel-right p-3" style={{ width: '65%', height: '100%', overflowY: 'auto' }}>
              {viewedCount === 0 ? (
                <div
                  className="text-muted d-flex align-items-center justify-content-center"
                  style={{ minHeight: '200px' }}
                >
                  Completa la primera sección para continuar
                </div>
              ) : (
                <>
                  {rightSections.map((section, i) => {
                    const globalIdx = i + 1;
                    if (globalIdx > viewedCount) return null;
                    const isCurrent = globalIdx === viewedCount;
                    const canContinue = isCurrent && !allDone &&
                      (!needsReady(section.type) || sectionReady[globalIdx]);
                    return (
                      <div key={i} className="training-section mb-4 border rounded p-3 bg-white">
                        <div className="section-title d-flex align-items-center justify-content-center gap-2 mb-2 w-100">
                          <strong>{section.name}</strong>
                        </div>
                        {renderViewer(section, globalIdx)}
                        {canContinue && (
                          <div className="text-end mt-3">
                            <button
                              className="btn btn-primary"
                              onClick={() => this.setState(prev => ({ viewedCount: prev.viewedCount + 1 }))}
                            >
                              Continuar <i className="fas fa-arrow-right ms-2" />
                            </button>
                          </div>
                        )}
                      </div>
                    );
                  })}

                  {allDone && (
                    <div className="text-center mt-4 mb-3">
                      {isAdmin ? (
                        <button className="btn btn-outline-primary btn-lg px-5" onClick={() => this.props.history.push(`/training/${userId}`)}>
                          <i className="fas fa-arrow-left me-2" />Volver a formaciones
                        </button>
                      ) : blockAlreadyApproved ? (
                        <>
                          <div className="alert alert-success d-inline-block mb-3">
                            <i className="fas fa-circle-check me-2" />
                            <strong>Ya completado</strong>
                          </div>
                          <br />
                          <button className="btn btn-outline-primary btn-lg px-5" onClick={() => this.props.history.goBack()}>
                            <i className="fas fa-arrow-left me-2" />Volver
                          </button>
                        </>
                      ) : (
                        <button
                          className="btn btn-success btn-lg px-5"
                          onClick={async () => {
                            const { userId, formationSlug, blockId } = this.props.match.params;
                            const { formation } = this.state;
                            try {
                              const token = localStorage.getItem('token');
                              await fetch(`${API_ROOT}promoters/${userId}/formations/${formation._id}/blocks/${blockId}/approve`, {
                                method: 'PATCH',
                                headers: { 'Content-Type': 'application/json', Authorization: `Token ${token}` },
                                body: JSON.stringify({ score: 100 }),
                              });
                            } catch (err) {
                              console.error('Error al guardar la lectura:', err);
                            }
                            this.setState({ dirty: false }, () => this.props.history.goBack());
                          }}
                        >
                          <i className="fas fa-check me-2" />Confirmar lectura
                        </button>
                      )}
                    </div>
                  )}
                </>
              )}
            </div>
          )}
        </div>
      </>
    );
  }
}

export default connect(state => ({ role: state.auth.role }))(TrainingTextSection);
